import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';

const LoginRedirect = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Redirect to the main app where the login logic lives
    navigate('/app', { replace: true });
  }, [navigate]);

  return (
    <Box 
      sx={{ 
        height: '100vh', 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center',
        bgcolor: '#f3f4f6'
      }}
    >
      <CircularProgress />
    </Box>
  );
};

export default LoginRedirect;
